module.exports = __webpack_public_path__ + "static/img/idcard-back.6df4ef76.png";